var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sky-charts',{attrs:{"colors":_vm.config.color,"extend":_vm.extend,"config":_vm.config,"chart-data":_vm.chartData,"showTitle":false,"showShadow":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }